import { useAppSelector } from "../../../../../redux/hooks/redux";
import { QuoteModeEnum } from "../../enums/quote-create.enums";

export const useQuoteTotal = (mode: QuoteModeEnum) => {
  const basicQuoteList = useAppSelector((state) => state.quoteList.basicQuotesList);
  const advancedQuoteList = useAppSelector((state) => state.quoteList.advancedQuoteslist);
  const getBasicTotal = () => {
    if (!Array.isArray(basicQuoteList) || basicQuoteList.length === 0) {
      return 0;
    }

    return basicQuoteList?.reduce((sum, item) => {
      const val = Number(item.total ?? 0);
      return sum + (Number.isFinite(val) ? val : 0);
    }, 0);
  };

  const getAdvancedTotal = () => {
    if (!advancedQuoteList.length) return 0;

    return advancedQuoteList.reduce((sum, quote) => {
      const sw = quote.sectorWorkflow;
      const val = sw?.costOverride?.value ?? sw?.total ?? 0;
      return sum + (Number.isFinite(val) ? Number(val) : 0);
    }, 0);
  };

  return mode === QuoteModeEnum.BASIC ? getBasicTotal() : getAdvancedTotal();
};
